import { connect } from "react-redux";
import { compose } from "redux";
import { selectIsDevicesLoaded } from "../../../../redux/assets/assetsSelectors";
import { createStructuredSelector } from "reselect";
import { selectIsGeofencesLoaded } from "../../../../redux/geofence/geofenceSelectors";

import WithSpinner from "../../../../components/withSpinner/withSpinner.component";
import GeofenceView from "./GeofenceView.jsx";

const mapStateToProps = createStructuredSelector({
  isLoading: (state) => !selectIsDevicesLoaded(state) || !selectIsGeofencesLoaded(state),
});

const GeofenceContainer = compose(
  connect(mapStateToProps),
  WithSpinner
)(GeofenceView);

export default GeofenceContainer; 